import React from 'react'
import './css/Headingcomp.css'
import WaveText from './WaveText'
import AnimateInView from './AnimateInView'

const Headingcomp = ({ heading, subheading, image }) => {
    return (
        <section className='heading-main-div'>
            <AnimateInView delay={0.2}>
            <div className='heading-main-div-content1'>
                <div className='heading-main-div-content1-content1'>
                    <h1 className='heading-main-div-content1-content1-heading'><WaveText text={heading}/></h1>
                </div>
                <div className='heading-main-div-content1-content2'>
                    <p className='heading-main-div-content1-content2-paragraph'>{subheading}</p>
                </div>
                <div className='heading-main-div-content1-content3'>
                    <img src={image} alt={heading} />
                </div>
            </div>
            </AnimateInView>
        </section>
    )
}

export default Headingcomp
